// Autogenerated locales - do not modify
/* tslint:disable quotemark variable-name */
export const SEO_TITLE_STROLLER_WISHLIST = "Ulo\u017een\u00e9 ko\u010d\u00edky - Ko\u010d\u00edkop\u00e9dia - datab\u00e1za ko\u010d\u00edkov";
export const STROLLER_SEO_GENERAL_DESC = "Ve\u013ek\u00e1 datab\u00e1za ko\u010d\u00edkov Modr\u00e9ho kon\u00edka";
export const STROLLER_SEO_WISHLIST = "V\u0161etky moje ob\u013e\u00faben\u00e9 ko\u010d\u00edky";
export const STROLLER_WISHLIST_TITLE = "Ulo\u017een\u00e9 ko\u010d\u00edky";
